import {
	connect
} from 'react-redux'
import GearModelList2Component from '../components/GearModelList2Component.jsx';
import {
	findGearModelList, 
	changeGearModelActivePage, 
	deleteGearModel, 
	openGearModelModal, 
	openGearModelUploadModal,
	findGearModel
} from '../actions';

const mapStateToProps = (state) => ({
	data: state.getIn(['gearModelListReducer', 'gearModelList']),
	activePage: state.getIn(['gearModelListReducer', 'activePage']),
	itemPerPage: state.getIn(['gearModelListReducer', 'itemPerPage']),
	totalPage: state.getIn(['gearModelListReducer', 'totalPage']),
	pagingMaxButtons: 5
})

const mapDispatchToProps = (dispatch) => ({
	refresh: (pagingData) => {
		dispatch(findGearModelList(pagingData));
	},
	changeActivepage: (pagingData) => {
		dispatch(changeGearModelActivePage(pagingData));
		dispatch(findGearModelList(pagingData));
	},
	deleteItems: (deleteKey, pagingData) => {
		dispatch(deleteGearModel(deleteKey, pagingData));
	},
	openAddModal: () => {
		dispatch(openGearModelModal({ forInsert: true }));
	},
	handleEdit: (pk) => {
		dispatch(findGearModel(pk));
		dispatch(openGearModelModal({ forInsert: false }));
	},
	openUploadModal: (pk) => {
		dispatch(findGearModel(pk));
		dispatch(openGearModelUploadModal());
	}
})

const GearModelList2Container = connect(
	mapStateToProps,
	mapDispatchToProps
)(GearModelList2Component)

export default GearModelList2Container;


// WEBPACK FOOTER //
// ./src/containers/GearModelList2Container.jsx